module.exports = __webpack_public_path__ + "img/ps-45.07fdb9b5.jpg";